import apiClient from '../apiClient';
import { POST_UPLOAD_IMAGE_ACCOMODATION_PROFILE_URL } from '../apiUrl';

const postUploadImageAccomodationProfileApi = data => {
  return apiClient.post(POST_UPLOAD_IMAGE_ACCOMODATION_PROFILE_URL, data);
};

export default postUploadImageAccomodationProfileApi;
